import { createContext } from 'react'

export const TranslatedWordsContext = createContext({})
